import { createContext, useEffect, useReducer, ReactElement } from 'react';

// third-party
import { Chance } from 'chance';

// reducer - state management
import { LOGIN, LOGOUT } from 'store/reducers/actions';
import authReducer from 'store/reducers/auth';

// project-imports
import Loader from 'components/Loader';
import axios from 'utils/axios';
import { AuthProps, JWTContextType } from 'types/auth';
import { APP_API_PATH } from 'config';
import { openSnackbar } from 'store/reducers/snackbar';
import { useNavigate } from 'react-router-dom';
import { dispatch as dspatch} from 'store';

const chance = new Chance();

// constant
const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null
};

// const verifyToken: (st: string) => boolean = (serviceToken) => {
//   if (!serviceToken) {
//     return false;
//   }
  // const decoded: KeyedObject = jwtDecode(serviceToken);

  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
//   return false;
// };

const setSession = (serviceToken?: string | null) => {
  if (serviceToken) {
    localStorage.setItem('serviceToken', serviceToken);
    axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
    if(axios.defaults.baseURL==APP_API_PATH){
      axios.defaults.baseURL=axios.defaults.baseURL+'nl';
    }
  } else {
    localStorage.removeItem('serviceToken');
    axios.defaults.baseURL=APP_API_PATH;
    delete axios.defaults.headers.common.Authorization;
  }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //

const JWTContext = createContext<JWTContextType | null>(null);

export const JWTProvider = ({ children }: { children: ReactElement }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const navigate = useNavigate();

  useEffect(() => {
      const init = async () => {
       await reloadUser();
      //  console.log('test');
       
      };
    init();
  }, []);

  const login = async (email: string, password: string) => {
    const response = await axios.post('nl',  { email, password });
    // const { serviceToken, user } = response.data;
    var user =response.data;
    setSession(response.data.token);
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        user
      }
    });
  };

  const register = async (email: string, password: string, first_name: string, last_name: string) => {
    // todo: this flow need to be recode as it not verified
    const id = chance.bb_pin();
    const response = await axios.post('/api/account/register', {
      id,
      email,
      password,
      first_name,
      last_name
    });
    let users = response.data;

    if (window.localStorage.getItem('users') !== undefined && window.localStorage.getItem('users') !== null) {
      const localUsers = window.localStorage.getItem('users');
      users = [
        ...JSON.parse(localUsers!),
        {
          id,
          email,
          password,
          name: `${first_name} ${last_name}`
        }
      ];
    }

    window.localStorage.setItem('users', JSON.stringify(users));
  };

  const logout = () => {
    setSession(null);
    dispatch({ type: LOGOUT });
  };

  const resetPassword = async (email: string) => {};
  const updatePassword = async (old_password:string,password:string,password_confirmation:string) => {
        try {
          const response = await axios.post('forgot',{old_password:old_password,password:password,password_confirmation:password_confirmation});
          dspatch(openSnackbar({open: true,message: 'Password Changed Success fully.',variant: 'alert',alert: {color: 'success'},close: true}));
          return response;
        } catch (err){
          dspatch(openSnackbar({open: true,message: 'Unable to change Password.',variant: 'alert',alert: {color: 'error'},close: true}));
          return err;
        }
  };

  const updateProfile = () => {};
  const reloadUser = async () => {
    try {
      const serviceToken = localStorage.getItem('serviceToken');
      if (serviceToken) {
        setSession(serviceToken);
        const response = await axios.get('');
        var user = response.data;
        dispatch({
          type: LOGIN,
          payload: {
            isLoggedIn: true,
            user
          }
        });
      } else {
        dispatch({
          type: LOGOUT
        });
        axios.defaults.baseURL=APP_API_PATH;
        delete axios.defaults.headers.common.Authorization;
        navigate('');
      }
    } catch (err) {
      dispatch({
        type: LOGOUT
      });
      axios.defaults.baseURL=APP_API_PATH;
      delete axios.defaults.headers.common.Authorization;
      navigate('');
    }

  };

  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }

  // @ts-ignore
  return <JWTContext.Provider value={{ ...state, login, logout, register, resetPassword, updateProfile,reloadUser,updatePassword }}>{children}</JWTContext.Provider>;
};

export default JWTContext;
